webpackJsonp([104101334113578],{

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = PaginationLink;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(44);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PaginationLink(props) {
	  if (!props.test) {
	    return _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.url },
	      props.text
	    );
	  } else {
	    return _react2.default.createElement(
	      "span",
	      null,
	      props.text
	    );
	  }
	}
	module.exports = exports["default"];

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PostTeaser = __webpack_require__(903);
	
	var _PostTeaser2 = _interopRequireDefault(_PostTeaser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PostList = function (_React$Component) {
	  _inherits(PostList, _React$Component);
	
	  function PostList() {
	    _classCallCheck(this, PostList);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostList.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      null,
	      this.props.data.map(function (_ref) {
	        var node = _ref.node;
	        return _react2.default.createElement(_PostTeaser2.default, {
	          key: node.id,
	          node: node
	        });
	      })
	    );
	  };
	
	  return PostList;
	}(_react2.default.Component);
	
	PostList.propTypes = {
	  data: _propTypes2.default.array.isRequired
	};
	
	exports.default = PostList;
	module.exports = exports['default'];

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  clear: both;\n  padding: 1rem;\n  margin-bottom: 2rem;\n  background-color: rgba(255, 255, 255, .4);\n  box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.3);\n  h1 {\n    margin-top: .5rem;\n  }\n  h3 {\n    margin-top: 0;\n  }\n  h4 {\n    margin-top: 1rem;\n  }\n'], ['\n  clear: both;\n  padding: 1rem;\n  margin-bottom: 2rem;\n  background-color: rgba(255, 255, 255, .4);\n  box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.3);\n  h1 {\n    margin-top: .5rem;\n  }\n  h3 {\n    margin-top: 0;\n  }\n  h4 {\n    margin-top: 1rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(18);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(44);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _date = __webpack_require__(73);
	
	var _PostImage = __webpack_require__(72);
	
	var _PostImage2 = _interopRequireDefault(_PostImage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TeaserWrapper = _styledComponents2.default.div(_templateObject);
	
	var PostTeaser = function (_React$Component) {
	  _inherits(PostTeaser, _React$Component);
	
	  function PostTeaser() {
	    _classCallCheck(this, PostTeaser);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PostTeaser.prototype.render = function render() {
	    var node = this.props.node;
	    var formattedDate = (0, _date.formatDate)(node.created);
	    if (node.post_type === 'link') {
	      return _react2.default.createElement(
	        TeaserWrapper,
	        { key: node.id },
	        _react2.default.createElement(
	          'h1',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: node.link },
	            node.title
	          )
	        ),
	        _react2.default.createElement(
	          'h4',
	          null,
	          '\u2014 ',
	          formattedDate
	        ),
	        node.relationships.image ? _react2.default.createElement(_PostImage2.default, { sizes: node.relationships.image.localFile.childImageSharp.sizes }) : null,
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: node.body.value } }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: node.fields.slug
	          },
	          'Permalink'
	        )
	      );
	    } else if (this.props.node.post_type === 'note') {
	      return _react2.default.createElement(
	        TeaserWrapper,
	        { key: node.id },
	        _react2.default.createElement(
	          'h4',
	          null,
	          '\u2014 ',
	          formattedDate
	        ),
	        node.relationships.image ? _react2.default.createElement(_PostImage2.default, { sizes: node.relationships.image.localFile.childImageSharp.sizes }) : null,
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: node.body.value } }),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          {
	            to: node.fields.slug
	          },
	          'Permalink'
	        )
	      );
	    }
	    // Everything else is a post
	    else {
	        return _react2.default.createElement(
	          TeaserWrapper,
	          null,
	          _react2.default.createElement(
	            'h1',
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                to: node.fields.slug
	              },
	              node.title
	            )
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            '\u2014 ',
	            formattedDate
	          ),
	          node.relationships.image ? _react2.default.createElement(_PostImage2.default, { sizes: node.relationships.image.localFile.childImageSharp.sizes }) : null,
	          _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: node.body.value } })
	        );
	      }
	  };
	
	  return PostTeaser;
	}(_react2.default.Component);
	
	PostTeaser.propTypes = {
	  node: _propTypes2.default.object.isRequired
	};
	
	exports.default = PostTeaser;
	module.exports = exports['default'];

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n"], ["\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  padding: 0 1rem;\n  @media all and (max-width: 1024px) {\n   grid-column: 1 / span 4;\n  }\n  @media all and (min-width: 1025px) {\n    grid-column: 1 / span 3;\n  }\n"], ["\n  padding: 0 1rem;\n  @media all and (max-width: 1024px) {\n   grid-column: 1 / span 4;\n  }\n  @media all and (min-width: 1025px) {\n    grid-column: 1 / span 3;\n  }\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: 0 1rem .5rem 0;\n  @media all and (max-width: 1024px) {\n    grid-column: 1 / span 4;\n    order: -1;\n    padding-left: 1rem;\n  }\n  @media all and (min-width: 1025px) {\n    grid-column: span 1;\n    > div {\n      position: fixed;\n      width: calc(100%/5.4);\n      height: 100vh;\n    }\n  }\n"], ["\n  padding: 0 1rem .5rem 0;\n  @media all and (max-width: 1024px) {\n    grid-column: 1 / span 4;\n    order: -1;\n    padding-left: 1rem;\n  }\n  @media all and (min-width: 1025px) {\n    grid-column: span 1;\n    > div {\n      position: fixed;\n      width: calc(100%/5.4);\n      height: 100vh;\n    }\n  }\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  li {\n    padding: .5rem;\n    background-color: rgba(255, 255, 255, .4);\n    box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.3);\n    list-style-type: none;\n    font-family: 'Montserrat',sans-serif;\n    color: hsla(0,0%,0%,0.5);\n    cursor: pointer;\n  }\n"], ["\n  li {\n    padding: .5rem;\n    background-color: rgba(255, 255, 255, .4);\n    box-shadow: 0px 0px 2px 1px rgba(0,0,0,0.3);\n    list-style-type: none;\n    font-family: 'Montserrat',sans-serif;\n    color: hsla(0,0%,0%,0.5);\n    cursor: pointer;\n  }\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(18);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(44);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PostList = __webpack_require__(902);
	
	var _PostList2 = _interopRequireDefault(_PostList);
	
	var _PaginationLink = __webpack_require__(901);
	
	var _PaginationLink2 = _interopRequireDefault(_PaginationLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Grid = _styledComponents2.default.div(_templateObject);
	
	var PostListWrapper = _styledComponents2.default.div(_templateObject2);
	
	var AsideWrapper = _styledComponents2.default.div(_templateObject3);
	
	var Totals = _styledComponents2.default.div(_templateObject4);
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexPage.prototype.componentDidMount = function componentDidMount() {
	    // Ensure that twitter embeds load (initial load)
	    setTimeout(function () {
	      if (typeof twttr !== "undefined" && window.twttr.widgets && typeof window.twttr.widgets.load === "function") {
	        window.twttr.widgets.load();
	      }
	    }, 0);
	  };
	
	  IndexPage.prototype.render = function render() {
	    // Define pagination related variables
	    var _props$pathContext = this.props.pathContext,
	        group = _props$pathContext.group,
	        index = _props$pathContext.index,
	        first = _props$pathContext.first,
	        last = _props$pathContext.last,
	        pageCount = _props$pathContext.pageCount;
	
	    var previousUrl = index - 1 == 1 ? "" : (index - 1).toString();
	    var nextUrl = (index + 1).toString();
	    return _react2.default.createElement(
	      Grid,
	      null,
	      _react2.default.createElement(
	        PostListWrapper,
	        null,
	        _react2.default.createElement(_PostList2.default, {
	          className: "post-list",
	          data: this.props.pathContext.group
	        })
	      ),
	      _react2.default.createElement(
	        AsideWrapper,
	        null,
	        _react2.default.createElement(
	          Totals,
	          { className: "post-type-controls" },
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/" },
	              "First"
	            )
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(_PaginationLink2.default, { test: first, url: previousUrl, text: "Next 5" })
	          ),
	          _react2.default.createElement(
	            "li",
	            null,
	            _react2.default.createElement(_PaginationLink2.default, { test: last, url: nextUrl, text: "Previous 5" })
	          )
	        )
	      )
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-index-js-5b7962c8ebf55c42a62c.js